import { InjectionToken } from '@angular/core';

export const DEFAULT_LOCALE = new InjectionToken<string>('default.locale');
